import ClickSlider from './components/click-slider';

import	{Greek}	from "../../js/flatpickr/l10n/gr";

function masonryGalleryInitialise() {
	let $gallery = $('.masonry-gallery');
	if ($gallery.length > 0) {

		if ($gallery.data('masonry')) {
			$gallery.imagesLoaded().progress( function() {
				// $gallery.isotope('layout');
			});
		}
	}
}

$(document).ready( function() {

	if (document.body.classList.contains('page-template-menu')) {
		let categoryButtons = document.querySelectorAll('#category-btn');
		if ( categoryButtons != null ) {
			for (let i=0; i<categoryButtons.length; i++) {
				categoryButtons[i].addEventListener('click', function() {
					let data_attr = categoryButtons[i].getAttribute('data-attr');
					let item_wrappers = document.querySelectorAll('#items-wrapper');
					for (let j=0; j<item_wrappers.length; j++) {
						item_wrappers[j].classList.add('d-none');
					}
					document.querySelector('#items-wrapper[data-attr="' + data_attr + '"]').classList.remove('d-none');
					let buttons = document.querySelectorAll('#category-btn');
					for (let j=0; j<buttons.length; j++) {
						buttons[j].classList.remove("active");
					}
					categoryButtons[i].classList.add('active');
				});
			}
		}
	}

	let top = window.pageYOffset || document.documentElement.scrollTop;
	if (top > 200 ) {
		document.body.classList.add( 'scrolled' );
	} else {
		document.body.classList.remove( 'scrolled' );
	}

	window.onscroll = function(){
		let top = window.pageYOffset || document.documentElement.scrollTop;
		if (top > 200 ) {
			document.body.classList.add( 'scrolled' );
		} else {
			document.body.classList.remove( 'scrolled' );
		}
	};

	masonryGalleryInitialise();

	function masonry_style() {
		let imgs = document.querySelectorAll('.masonry-gallery .gallery-item');
		if (imgs != null && imgs.length > 0) {
			for (let i = 0; i < imgs.length; i++) { imgs[i].classList.remove('masonry-m-odd'); }

			let $gallery = $('.masonry-gallery');
			$gallery.isotope('layout');

			for (let i = 0; i < imgs.length; i++) {
				if (imgs[i].style.left === '0%')
					imgs[i].classList.add('masonry-m-odd');
			}
		}
	}
	masonry_style();

	let title_wrapper = $( '#title-wrapper' );
	let title_wrapper2 = $( '#title-wrapper-2' );
	let title_wrapper3 = $( '#title-wrapper-3' );
	let title_wrapper4 = $( '#title-wrapper-4' );
	let wrapper_follower = $( '.wrapper-follower' );

	function wrapper_sizing(elem) {
		if ( typeof elem !== undefined && typeof wrapper_follower !== undefined && typeof wrapper_follower.offset() !== 'undefined' && typeof elem.offset() !== 'undefined' ) {
			elem.attr('style', 'width:' + (wrapper_follower.offset().left + wrapper_follower.width()) + 'px');
		}
	}

	wrapper_sizing(title_wrapper);
	wrapper_sizing(title_wrapper2);
	wrapper_sizing(title_wrapper3);
	wrapper_sizing(title_wrapper4);

	window.addEventListener("resize", function () {
		wrapper_sizing(title_wrapper);
		wrapper_sizing(title_wrapper2);
		wrapper_sizing(title_wrapper3);
		wrapper_sizing(title_wrapper4);
		masonry_style();
	});

	if (document.body.classList.contains('page-template-reservations')) {
		if ( document.getElementById( 'reservation-form' ) ) {
			let wpml_lunch = document.getElementById('wpml-lunch').innerText;
			let wpml_dinner = document.getElementById('wpml-dinner').innerText;
			let label_people = document.getElementById('label-people');
			let label_date = document.getElementById('label-date');
			let label_hour = document.getElementById('label-hour');
			let selectedDayIndex = -1;
			let currentCalState = true;
			let weekDayNames = [];
			function getWeekDayNames() {
				let calWeekdays = document.querySelectorAll('.flatpickr-weekdays .flatpickr-weekdaycontainer .flatpickr-weekday');
				for (let i=0; i<calWeekdays.length; i++) {
					weekDayNames.push(calWeekdays[i].innerText);
				}
			}
			function weekDaySafeGuard(reset=false) { return;
				let calWeekdays = document.querySelectorAll('.flatpickr-weekdays .flatpickr-weekdaycontainer .flatpickr-weekday');

				if (reset) {
					for (let i=0; i<calWeekdays.length; i++) {
						calWeekdays[i].innerText = weekDayNames[i];
					}
					return;
				}

				const today = new Date();
				let todayNum = today.getDay();
				if (todayNum != 0) {
					let weekDaysSubBefore = weekDayNames.slice(0, todayNum);
					let weekDaysSubAfter = weekDayNames.slice(todayNum,8);
					let fixedWeekDays = weekDaysSubAfter.concat(weekDaysSubBefore);
					for (let i=0; i<calWeekdays.length; i++) {
						calWeekdays[i].innerText = fixedWeekDays[i];
					}
				}
			}
			function toggleCalendar(visible) {
				let calMonths = document.querySelector('.flatpickr-months');
				if (visible === false) {
					if (calMonths != null){
						calMonths.classList.add('d-none');
						document.querySelector('.dayContainer').classList.remove('expanded');
					}

					let days = document.querySelectorAll('.flatpickr-days .dayContainer span');
					for (let i=0; i<days.length; i++) {
						days[i].classList.add('d-none');
					}
					toggleDays();
				}
				else {
					calMonths.classList.remove('d-none');
					document.querySelector('.dayContainer').classList.add('expanded');
					let days = document.querySelectorAll('.flatpickr-days .dayContainer span');
					for (let i=0; i<days.length; i++) {
						days[i].classList.remove('d-none');
					}
				}
				currentCalState = visible;
			}
			function toggleDays() {
				let days = document.querySelectorAll('.flatpickr-days .dayContainer span');
				selectedDayIndex=-1;
				for (let i=0; i<days.length; i++) {
					if (days[i].classList.contains('selected')) {
						selectedDayIndex = Math.floor(i/7) * 7;
						break;
					}
				}
				if (selectedDayIndex === -1) {
					for (let i=0; i<days.length; i++) {
						if (days[i].classList.contains('today')) {
							selectedDayIndex = i;
							break;
						}
					}
				}
				if ( selectedDayIndex !== -1) {
					for (let i=selectedDayIndex; i<selectedDayIndex+7; i++) {
						if (typeof days[i] !== 'undefined')
							days[i].classList.remove('d-none');
					}
				}
				else {
					let picker = document.getElementById('res-picker');
					if (typeof picker._flatpickr != 'undefined') {
						picker._flatpickr.setDate('today');
						toggleCalendar(false);
					}
				}
			}
			toggleCalendar(false);
			function strToDate(str) {
				var parts = str.split('-');
				return new Date(parts[2], parts[1] - 1, parts[0]);
			}
			function getDateNumber(dateStr) {
				var parts = dateStr.split('-');
				var myDate = new Date(parts[2], parts[1] - 1, parts[0]);
				return myDate.getDay();
			}
			function getDayName(dateStr, locale) {
				var date = new Date(dateStr);
				return date.toLocaleDateString(locale, { weekday: 'long' });
			}
			function getMonthName(dateStr, locale) {
				var date = new Date(dateStr);
				return date.toLocaleDateString(locale, { month: 'short' });
			}
			function disableAllTimes() {
				let dinners = document.querySelectorAll('.dinner-day');
				let lunches = document.querySelectorAll('.lunch-day');
				for (let i=0; i<dinners.length; i++) {dinners[i].classList.add('d-none');}
				for (let i=0; i<lunches.length; i++) {lunches[i].classList.add('d-none');}
			}
			function todayFormatted() {
				let today = new Date();
				const yyyy = today.getFullYear();
				let mm = today.getMonth() + 1; // Months start at 0!
				let dd = today.getDate();

				if (dd < 10) dd = '0' + dd;
				if (mm < 10) mm = '0' + mm;
				today = dd + '-' + mm + '-' + yyyy;
				return today;
			}
			function toggleSelectedTimeTable(selectedDayNumber) {
				disableAllTimes();
				let l = document.querySelector('.lunch-day-' + selectedDayNumber);
				let d = document.querySelector('.dinner-day-' + selectedDayNumber);

				if (typeof l !== 'undefined') {
					l.classList.remove('d-none');
				}
				if (typeof d !== 'undefined') {
					d.classList.remove('d-none');
				}
			}
			function updateReservationLabels() {
				let resType = document.getElementById('reservationType').value;
				let peopleVal = document.getElementById('people_value').innerText;
				let str = resType === 'Dinner' ? wpml_dinner : wpml_lunch;
				label_people.innerText = str + " " + peopleVal;
				let currentDateStr = document.getElementById('res-picker').value !== '' ? document.getElementById('res-picker').value : todayFormatted();
				let currentDate = strToDate(currentDateStr);
				let day = getDayName(currentDate, $('html')[0].lang);
				let month = getMonthName(currentDate, $('html')[0].lang);
				let dayOfWeek = currentDate.getDate();
				let nth = function(d) {
					if ($('html')[0].lang == 'en-US') {
						if (d > 3 && d < 21) return 'th';
						switch (d % 10) {
						case 1:
							return "st";
						case 2:
							return "nd";
						case 3:
							return "rd";
						default:
							return "th";
						}
					} else {
						return '';
					}
				};
				label_date.innerText = day + " " + month + " " + dayOfWeek + nth(dayOfWeek);
				label_hour.innerText = document.getElementById('reservationHour').value !== '' ? "@" + document.getElementById('reservationHour').value : '-';
			}
			function resTypeSetValue(val, t) {
				document.getElementById('reservationType').value = val;
				document.getElementById('reservationType').setAttribute('value',val);
				document.getElementById('reservationHour').value = t.innerText;
				document.getElementById('reservationHour').setAttribute('value',t.innerText);
				resetButtons();
				t.classList.add('res-selected');
				updateReservationLabels();
			}
			function resetValues() {
				document.getElementById('reservationHour').value = '';
				document.getElementById('reservationHour').setAttribute('value','');
			}
			updateReservationLabels();
			toggleSelectedTimeTable(getDateNumber(todayFormatted()));
			function onDateChange() {
				let cf7_dates = document.getElementById('date');
				cf7_dates.value = document.getElementById('res-picker').value;
				if (currentCalState === false) {
					toggleCalendar(false, true);

				}
				let v = document.getElementById('res-picker').value !== '' ? document.getElementById('res-picker').value : todayFormatted();
				let selectedDayNumber = getDateNumber(v);
				toggleSelectedTimeTable(selectedDayNumber);
				resetValues();
				updateReservationLabels();
			}
			document.getElementById('toggleCalendar').addEventListener('click', () => {
				if (currentCalState == true) {
					let picker = document.getElementById('res-picker');
					let pickerField = document.getElementById('res-picker');
					let dd = pickerField.value.split('-');
					if (dd.length != 0) {
						let fixedSelected = dd[1] + "-" + dd[0] + "-" + dd[2]
						var fixedSelectedDate = new Date(fixedSelected);
						var today = new Date();

						var date1 = Date.UTC(fixedSelectedDate.getFullYear(), fixedSelectedDate.getMonth(), fixedSelectedDate.getDate());
						var date2 = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
						var ms = Math.abs(date1-date2);
						if (Math.floor(ms/1000/60/60/24) > 7) {
							picker._flatpickr.setDate('today');
						}
					}

				}
				toggleCalendar(!currentCalState);

				weekDaySafeGuard(currentCalState);
			});
			class DatePicker {
				constructor(checkInEl = null) {
					if ( checkInEl ) {
						this.checkInEl = checkInEl;

						// flatpickr.l10ns.default.firstDayOfWeek = 1; // Monday
						// flatpickr.localize(flatpickr.l10ns.gr); // Use greek language

						flatpickr(this.checkInEl, {
							locale: $('html')[0].lang == 'el' ? 'gr' : $('html')[0].lang,
							minDate: 'today',
							dateFormat: 'd-m-Y',
							//plugins: [new rangePlugin({ input: checkOutEl})],
							disableMobile: 'true',
							inline: true,
							defaultDate: "today",
							onChange : function() {
								onDateChange();
							}
						});
					}
				}
			}
			let picker = document.getElementById('res-picker');
			if (picker) {
				let checkinField = new DatePicker(picker);
				getWeekDayNames();
				toggleCalendar(false);
				weekDaySafeGuard();
			}
			let people_value = document.getElementById('people_value');
			let cf7_people = document.getElementById('people');
			let occupancy_min = parseInt(document.getElementById('occupancy_min').innerText);
			let occupancy_max = parseInt(document.getElementById('occupancy_max').innerText);
			cf7_people.value = occupancy_min;
			document.getElementById('people_minus').addEventListener('click', function() {
				let v = parseInt(people_value.innerText);
				if ( v > occupancy_min ) {
					v--;
					document.getElementById('people_value').innerText = v.toString();
					document.getElementById('people').value = v.toString();
					updateReservationLabels();
				}
			});
			document.getElementById('people_add').addEventListener('click', function() {
				let v = parseInt(people_value.innerText);
				if ( v < occupancy_max ) {
					v++;
					document.getElementById('people_value').innerText = v.toString();
					document.getElementById('people').value = v.toString();
					updateReservationLabels();
				}
			});
			let lunch_buttons = document.querySelectorAll('.res-lunch');
			let dinner_buttons = document.querySelectorAll('.res-dinner');
			function resetButtons() {
				for (let i = 0; i < lunch_buttons.length; i++) {
					lunch_buttons[i].classList.remove('res-selected');
				}
				for (let i = 0; i < dinner_buttons.length; i++) {
					dinner_buttons[i].classList.remove('res-selected');
				}
			}
			for (let i = 0; i < lunch_buttons.length; i++) {
				let self = lunch_buttons[i];
				self.addEventListener('click', function (event) {
					resTypeSetValue('Lunch', this);
				}, false);
			}
			for (let i = 0; i < dinner_buttons.length; i++) {
				var self = dinner_buttons[i];
				self.addEventListener('click', function (event) {
					resTypeSetValue('Dinner', this);
				}, false);
			}
			function todayFormat() {
				let today = new Date();
				const yyyy = today.getFullYear();
				let mm = today.getMonth() + 1; // Months start at 0!
				let dd = today.getDate();

				if (dd < 10) dd = '0' + dd;
				if (mm < 10) mm = '0' + mm;
				today = dd + '-' + mm + '-' + yyyy;
				return today;
			}

			setTimeout(() => {
				let date = document.getElementById('date');
				if ( date.value == "" ) {
					date.value = todayFormat();
					console.log(date.value)
				}
				let people = document.getElementById('people');

				if ( people.value == "" ) {
					people.value = document.getElementById('occupancy_min').innerHTML;
					console.log(people.value);
				}
			},300);
		}
	}


	if (document.body.classList.contains('home')) {

		const clickSlider = document.querySelectorAll('.click-slider')
		if ( clickSlider ) {
			console.log(clickSlider);
			clickSlider.forEach( slider => {
				return new ClickSlider(slider)
			})
		}

		console.log(typeof gsap)
	}

	if ( document.getElementById( 'awards' ) ) {
		console.log("hey");
		let award_title = document.getElementById( 'award-title' );
		document.querySelectorAll( '.award' ).forEach ( award => {
			award.addEventListener( 'mouseenter', () => {
				award_title.innerText = award.dataset.title;
				setTimeout(() => {
					award_title.style.opacity = 1;
				}, this.animationDelay + 2000);
			} )
			award.addEventListener( 'mouseleave', () => {
				setTimeout(() => {
					award_title.style.opacity = 0;
				}, this.animationDelay + 2000);
			} )
		});
	}

	if (document.body.classList.contains('page-template-gallery')) {
		let categories = document.querySelectorAll('.media-category-wrapper');
		let categoryTabs = document.querySelectorAll('.js-media-category');
		for (let i=0; i<categoryTabs.length; i++) {
			categoryTabs[i].addEventListener('click', function() {
				let target = this.getAttribute('data-target');
				for (let j=0; j<categories.length; j++) {
					categories[j].classList.add('d-none');
				}
				for (let j=0; j<categoryTabs.length; j++) {
					categoryTabs[j].classList.remove('active-tab');
				}
				categoryTabs[i].classList.add('active-tab');
				document.querySelector('.media-category-wrapper.' + target).classList.remove('d-none');
			})
		}
	}

	// if (document.body.classList.contains('page-template-events') || document.body.classList.contains('home')) {
	// 	let homeSliderIndex=0;
	// 	function homeSliderSelectedIndex(index, category) {
	// 		let btn_next = document.getElementById('event-slider-next');
	// 		let btn_prev = document.getElementById('event-slider-prev');
	// 		let items = document.querySelectorAll('#gast_event_inner_wrapper[data-attr="' + category + '"] #gast_event_inner_btn');
	// 		if (parseInt(index) == 0) {
	// 			btn_prev.classList.add('d-none');
	// 			btn_prev.setAttribute('data-attr', '-1');
	// 		}
	// 		else {
	// 			btn_prev.classList.remove('d-none');
	// 			btn_prev.querySelector('span').innerText = items[parseInt(index) - 1].outerText;
	// 			btn_prev.setAttribute('data-attr', parseInt(index) - 1);
	// 			btn_prev.setAttribute('data-attr2', category);
	// 		}
	// 		if (parseInt(index) + 1 >= items.length) {
	// 			btn_next.classList.add('d-none');
	// 			btn_next.setAttribute('data-attr', '-1');
	// 		}else {
	// 			btn_next.classList.remove('d-none');
	// 			btn_next.querySelector('span').innerText = items[parseInt(index) + 1].outerText;
	// 			btn_next.setAttribute('data-attr', parseInt(index) + 1);
	// 			btn_next.setAttribute('data-attr2', category);
	// 		}
	//
	// 		homeSliderIndex = index;
	// 	}
	// 	homeSliderSelectedIndex(0,0);
	//
	// 	function changeSlide(slide,category) {
	// 		let button = document.querySelector('#gast_event_inner_btn[data-attr="' + category + slide + '"]');
	// 		let data_attr = button.getAttribute('data-attr');
	// 		let item_wrappers = document.querySelectorAll('#home_event_wrapper');
	// 		for (let j=0; j<item_wrappers.length; j++) {
	// 			item_wrappers[j].classList.add('d-none');
	// 		}
	// 		document.querySelector('#home_event_wrapper[data-attr="' + data_attr + '"]').classList.remove('d-none');
	// 		let buttons = document.querySelectorAll('#gast_event_inner_btn');
	// 		for (let j=0; j<buttons.length; j++) {
	// 			buttons[j].classList.remove("active");
	// 		}
	// 		button.classList.add('active');
	// 		let data_attr2 = button.getAttribute('data-attr2');
	// 		let data_attr3 = button.getAttribute('data-attr3');
	// 		homeSliderSelectedIndex(data_attr2,data_attr3);
	// 	}
	//
	// 	document.querySelector('#event-slider-next button').addEventListener('click', function() {
	// 		let nxt = document.getElementById('event-slider-next');
	// 		changeSlide(nxt.getAttribute('data-attr'),nxt.getAttribute('data-attr2'));
	// 	});
	// 	document.querySelector('#event-slider-prev button').addEventListener('click', function() {
	// 		let prv = document.getElementById('event-slider-prev');
	// 		changeSlide(prv.getAttribute('data-attr'),prv.getAttribute('data-attr2'));
	// 	});
	//
	// 	let eventButtons = document.querySelectorAll('#gast_event_btn');
	// 	if ( eventButtons != null ) {
	// 		for (let i=0; i<eventButtons.length; i++) {
	// 			eventButtons[i].addEventListener('click', function() {
	// 				let is_home = document.body.classList.contains('home');
	// 				let data_attr = eventButtons[i].getAttribute('data-attr');
	// 				let item_wrappers = document.querySelectorAll('#gast_event_wrapper');
	// 				for (let j=0; j<item_wrappers.length; j++) {
	// 					item_wrappers[j].classList.add('d-none');
	// 				}
	// 				document.querySelector('#gast_event_wrapper[data-attr="' + data_attr + '"]').classList.remove('d-none');
	// 				let buttons = document.querySelectorAll('#gast_event_btn');
	// 				for (let j=0; j<buttons.length; j++) {
	// 					buttons[j].classList.remove("active");
	// 				}
	// 				eventButtons[i].classList.add('active');
	//
	// 				if (is_home) {
	// 					let item_wrappers_inner = document.querySelectorAll('#gast_event_inner_wrapper');
	// 					for (let j=0; j<item_wrappers_inner.length; j++) {
	// 						item_wrappers_inner[j].classList.add('d-none');
	// 					}
	// 					document.querySelector('#gast_event_inner_wrapper[data-attr="' + data_attr + '"]').classList.remove('d-none');
	// 					let item_wrappers_inner_btns = document.querySelectorAll('#home_event_wrapper');
	// 					for (let j=0; j<item_wrappers_inner_btns.length; j++) {
	// 						item_wrappers_inner_btns[j].classList.add('d-none');
	// 					}
	// 					let selected_inner_btns = document.querySelectorAll('#home_event_wrapper[data-attr2="' + data_attr + '"]');
	// 					if ( typeof selected_inner_btns[0] != 'undefined' ) {
	// 						selected_inner_btns[0].classList.remove('d-none');
	// 					}
	// 					homeSliderSelectedIndex(0, data_attr);
	// 				}
	// 			});
	// 		}
	// 	}
	// 	if (document.body.classList.contains('home')) {
	// 		let eventInnerButtons = document.querySelectorAll('#gast_event_inner_btn');
	// 		if ( eventInnerButtons != null ) {
	// 			for (let i=0; i<eventInnerButtons.length; i++) {
	// 				eventInnerButtons[i].addEventListener('click', function() {
	// 					changeSlide(eventInnerButtons[i].getAttribute('data-attr2'), eventInnerButtons[i].getAttribute('data-attr3'));
	// 				});
	// 			}
	// 		}
	// 	}
	// }
});

